// extracted by mini-css-extract-plugin
export default {"wrap":"ls-z","fullWidth":"ms-z","items":"ns-z","featureCss":"os-z","disabled":"ps-z","imgCss":"qs-z"};